var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confessContainer"},[(_vm.feedback)?_c('em',[_vm._v(_vm._s(_vm.feedback))]):_vm._e(),_vm._v(" "),_c('confessItem',{attrs:{"data":_vm.confessions[0]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5bf3e2e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/confessions/confessionPages/confess.vue
// module id = 591
// module chunks = 0